import * as fromDatatype from "../datatype-library/index";

export interface bl_mkp_entity_branch_stock_balance_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  entity_branch_hdr_guid: fromDatatype.GuidDataFieldInterface;
  merchant_guid: fromDatatype.GuidDataFieldInterface;
  mkp_item_guid: fromDatatype.GuidDataFieldInterface;
  mkp_item_code: fromDatatype.VarcharDatatypeInterface;
  fi_item_guid: fromDatatype.GuidDataFieldInterface;
  fi_item_code: fromDatatype.VarcharDatatypeInterface;
  qty_available: fromDatatype.NumericDatatypeInterface;
  qty_reserved: fromDatatype.NumericDatatypeInterface;
  qty_ecom_buffer: fromDatatype.NumericDatatypeInterface;
  qty_sales_order_open: fromDatatype.NumericDatatypeInterface;
  qty_min_level: fromDatatype.NumericDatatypeInterface;
  qty_max_level: fromDatatype.NumericDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  status: fromDatatype.VarcharDatatypeInterface;
  revision: fromDatatype.GuidDataFieldInterface;
  vrsn: fromDatatype.VarcharDatatypeInterface;
  qty_balance: fromDatatype.NumericDatatypeInterface;
}

export class bl_mkp_entity_branch_stock_balance_RowClass implements bl_mkp_entity_branch_stock_balance_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  entity_branch_hdr_guid: fromDatatype.GuidDataFieldInterface;
  merchant_guid: fromDatatype.GuidDataFieldInterface;
  mkp_item_guid: fromDatatype.GuidDataFieldInterface;
  mkp_item_code: fromDatatype.VarcharDatatypeInterface;
  fi_item_guid: fromDatatype.GuidDataFieldInterface;
  fi_item_code: fromDatatype.VarcharDatatypeInterface;
  qty_available: fromDatatype.NumericDatatypeInterface;
  qty_reserved: fromDatatype.NumericDatatypeInterface;
  qty_ecom_buffer: fromDatatype.NumericDatatypeInterface;
  qty_sales_order_open: fromDatatype.NumericDatatypeInterface;
  qty_min_level: fromDatatype.NumericDatatypeInterface;
  qty_max_level: fromDatatype.NumericDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  status: fromDatatype.VarcharDatatypeInterface;
  revision: fromDatatype.GuidDataFieldInterface;
  vrsn: fromDatatype.VarcharDatatypeInterface;
  qty_balance: fromDatatype.NumericDatatypeInterface;

  
}
